import { Component } from '@angular/core';

@Component({
  selector: 'app-home-testimonials-v2',
  templateUrl: './home-testimonials-v2.component.html',
  styleUrl: './home-testimonials-v2.component.scss'
})
export class HomeTestimonialsV2Component {

}
